import { getPageTitle, getPageSubtitle, getBackTarget } from "./pageTitles";
import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useSidebar } from "./SidebarContext";

import "./rc-admin.scss";

// ── Page title map ─────────────────────────────────────────────────────────────

// ── Icons ──────────────────────────────────────────────────────────────────────

const IUser = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="7"
      r="4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IBell = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.73 21a2 2 0 0 1-3.46 0"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ── Shared top bar ─────────────────────────────────────────────────────────────

const IBack = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <path d="M7 3L2 8L7 13M2 8H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IMenu = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const RCTopBar = () => {
  const { pathname } = useLocation();
  const history      = useHistory();
  const { openMobileNav } = useSidebar();
  const title    = getPageTitle(pathname);
  const subtitle = getPageSubtitle(pathname);

  const goBack = () => {
    const target = getBackTarget(pathname);
    if (target) history.push(target);
    else history.goBack();
  };

  // Heading only on mobile — sticky nav lives in AppShell MobileTopbar.
  return (
    <div className="rc-topbar">
      <div className="rc-topbar__heading">
        <button type="button" className="rc-back-btn" onClick={goBack} aria-label="Back">
          <IBack />
        </button>
        {title && (
          <div className="rc-topbar__title-group">
            <div className="rc-topbar__page-title">{title}</div>
            {subtitle && <span className="rc-topbar__page-subtitle">{subtitle}</span>}
          </div>
        )}
      </div>

      <div className="rc-topbar__nav-strip">
        <button
          type="button"
          className="rc-menu-btn rc-topbar-control--mobile"
          onClick={openMobileNav}
          aria-label="Open menu"
        >
          <IMenu />
        </button>

        {/* No profile button and no bell. This strip predates the app shell and
            duplicated it at every width — a second bell under the AppTopbar's on
            a laptop, and under AppMobileTopbar's on a phone. It showed up on the
            Overview page's own title line because /rc/overview is the one RC
            Admin route without `noTopBar` (Alex, 2026-09-25). Profile is a
            sidebar destination now, so the button had nothing left to offer. */}
      </div>
    </div>
  );
};

// ── Layout ─────────────────────────────────────────────────────────────────────

const RCAdminLayout = ({ content: Content, context, noTopBar, ...props }) => (
  <div className="rc-admin-layout">
    <div className="rc-admin-layout__content">
      {!noTopBar && <RCTopBar />}
      <Content {...props} user={context?.user} />
    </div>
  </div>
);

export default RCAdminLayout;
